import DisbursementSummary from '../disbursements/models/DisbursementSummary';
import AdvancedSearchCriteria from '../search/models/AdvancedSearchCriteria';
import AdvancedSearchOption from '../search/models/AdvancedSearchOption';

export const getSelectedAdvancedSearchFilterLabels = (
  criteria: AdvancedSearchCriteria | undefined,
  searchOptions: AdvancedSearchOption[],
  pendingKey?: string,
): string => {
  const selectedFilterKeys = new Set<string>(
    Object.entries(criteria || {})
      .filter(([, value]) => Array.isArray(value) && value.length > 0)
      .map(([key]) => key),
  );

  if (criteria?.startDate && criteria?.endDate) {
    selectedFilterKeys.add('paidDate');
  }

  if (pendingKey) {
    selectedFilterKeys.add(pendingKey);
  }

  return searchOptions
    .filter((option) => selectedFilterKeys.has(option.key))
    .map((option) => option.label)
    .sort()
    .join(',');
};

export const getUniqueDisbursementPaidDates = (disbursements: DisbursementSummary[]): string[] =>
  Array.from(new Set(disbursements.map(({ paidDate }) => paidDate))).sort(
    (paidDateA, paidDateB) => new Date(paidDateB).valueOf() - new Date(paidDateA).valueOf(),
  );
